import { createContext } from 'react'
import { UserRole } from '@/application/auth/types/userRole'

export type AuthContextValue = {
  isAuthenticated: boolean
  name: string | null
  email: string | null
  roles: UserRole[]
  hasRole: (role: UserRole) => boolean
  hasAnyRole: (roles: UserRole[]) => boolean
  logout: () => void
}

export const defaultValue: AuthContextValue = {
  isAuthenticated: false,
  name: null,
  email: null,
  roles: [],
  hasRole: () => false,
  hasAnyRole: () => false,
  logout: () => {}
}

export const AuthContext = createContext<AuthContextValue>(defaultValue)
